define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var TimeFrameManager = require('web-agent-utils/TimeFrameManager');
    var DateTimeUtils = require('web-agent-utils/DateTimeUtils');
    var ButtonDropdownViewController = require('web-agent-components/ButtonDropdownViewController');

    var TimeFrameViewController = ViewController.extend({
        ControllerName: 'TimeFrameViewController',
        NowKey: DateTimeUtils.NOW_KEY,

        LPViewMap: {
            datePickerStart: ".lpview_datePicker_start",
            datePickerEnd: ".lpview_datePicker_end",
            title_start: ".lpview_title_start",
            title_end: ".lpview_title_end",
            date_input_start: ".lpview_date_input_start",
            date_input_end: ".lpview_date_input_end",
            time_input_start: ".lpview_time_input_start",
            time_input_end: ".lpview_time_input_end"
        },
        LPClassesMap: {
        },

        initialize: function (constructorData) {

            this.viewElement = this.createView({templateFile: "LP_date_time_frame_view.html"});
            // preset filters
            if (constructorData.defaultFilter && constructorData.defaultFilter.startDate && constructorData.defaultFilter.endDate) {
                this.defaultFilter = lpUtils.cloneObject(constructorData.defaultFilter);
                if(_.isNumber(this.defaultFilter.startDate)) {
                    this.defaultFilter.startDate = new Date(this.defaultFilter.startDate);
                }
                if(_.isNumber(this.defaultFilter.endDate)) {
                    this.defaultFilter.endDate = new Date(this.defaultFilter.endDate);
                }
            } else {
                this.defaultFilter = this.getFallbackTimeFrame();
            }

            this.uiData = lpUtils.cloneObject(this.defaultFilter);

            if(_.isNumber(constructorData.maxDaysDuration)) {
                this.maxDaysDuration = constructorData.maxDaysDuration;
            }

            this.setFocusHandler = constructorData.setFocusHandler || $.noop;
            this.scrollableContainer = constructorData.scrollableContainer;

        },

        events: function () {

        },

        render: function () {
            // calculate the date 13 month ago
            var calculate13Month = DateTimeUtils.createDateFromLong(new Date());
            calculate13Month.setMonth(calculate13Month.getMonth() - 13);

            // Add timeFrame
            this.timeFrame = TimeFrameManager.createInstance({
                datePicker: {
                    start: {
                        element: $(this.viewElement).find(this.LPViewMap.datePickerStart),
                        defaultDate: this.uiData.startDate
                    },
                    end: {
                        element: $(this.viewElement).find(this.LPViewMap.datePickerEnd),
                        defaultDate: this.uiData.endDate === this.NowKey ? DateTimeUtils.createDateFromLong(new Date()) : this.uiData.endDate
                    }
                },
                dateFormat: "ISO8601",
                maxDaysForTimeframeValue: this.maxDaysDuration,
                minDate: calculate13Month,
                maxDate:  new Date(),
                callback: this.timeFrameChange,
                setFocusCallback: this.setFocusHandler,
                context: this
            });

            // Add TimeDropdown start
            this.startTimeVC = new ButtonDropdownViewController({
                items: DateTimeUtils.getHoursItems(),
                selectedIndex: DateTimeUtils.getIndexOfTime(this.uiData.startDate) + 1,
                context: this,
                itemClicked: this.startTimeChange,
                lostFocusCallback: this.setFocusHandler,
                textProperty: "value",
                scrollableContainer: this.scrollableContainer
            });

            this.addViewController({viewController: this.startTimeVC, target: this.LPViewMap.time_input_start});

            // Add TimeDropdown end
            this.endTimeVC = new ButtonDropdownViewController({
                items: DateTimeUtils.getHoursItems(true),
                selectedIndex: DateTimeUtils.getIndexOfTime(this.uiData.endDate, true) + 1,
                context: this,
                itemClicked: this.endTimeChange,
                lostFocusCallback: this.setFocus,
                textProperty: "value",
                scrollableContainer: this.scrollableContainer
            });

            this.addViewController({viewController: this.endTimeVC, target: this.LPViewMap.time_input_end});

            this.refresh();
        }
    });

    /**
     * getter for UI data
     * @returns {{startDate: Date, endDate: Date}}
     */
    TimeFrameViewController.prototype.getUIData = function() {
        return this.uiData;
    };

    /**
     * setter for UI data
     * @param {{startDate: Date, endDate: Date}} data
     */
    TimeFrameViewController.prototype.setUIData = function(data) {
        this.uiData= data;
    };

    /**
     * Returns the now state - end = now, start = -7 Days
     * @returns {{startDate: Date, endDate: String}}
     */
    TimeFrameViewController.prototype.getFallbackTimeFrame = function(){
        var today = DateTimeUtils.createDateFromLong(new Date().getTime());

        var last7D = DateTimeUtils.createDateFromLong(new Date(today - (7 * 24 * 60 * 60 * 1000)));
        return {
            startDate:last7D ,
            endDate: this.NowKey
        };
    };

    /**
     * Callback function for changes in the timeFrame
     * @param data
     */
    TimeFrameViewController.prototype.timeFrameChange = function (data) {
        // We're changing the day only - not the time. That's why we're setting
        // the date manually, instead of simply copying the data.
        var oldStart = this.uiData.startDate.getTime();

        this.uiData.startDate.setFullYear(data.startDate.getFullYear(), data.startDate.getMonth(), data.startDate.getDate());

        var endDate = this.uiData.endDate;
        if (endDate === this.NowKey) {
            endDate = DateTimeUtils.createDateFromLong(new Date());
        }
        var oldEnd = DateTimeUtils.createDateFromLong(new Date(endDate.getTime()));

        endDate.setFullYear(data.endDate.getFullYear(), data.endDate.getMonth(), data.endDate.getDate());

        if (endDate.getTime() !== oldEnd.getTime()) {
            this.uiData.endDate = endDate;
        }

        if (oldStart != this.uiData.startDate.getTime()) { // the user update the start date
            this.checkStartDateChange();
        } else {
            this.checkEndDateChange();
        }

        this.updateDateInputs();
        this.refresh();
        this.setFocusHandler();
    };
    /**
     * Update the value of the inputs with the dates value
     */
    TimeFrameViewController.prototype.updateDateInputs = function () {
        this.getFirstElement(this.LPViewMap.date_input_start).value = lpUtils.formatDateAsString(this.uiData.startDate, true);
        var endDate = this.uiData.endDate;
        if (this.uiData.endDate === this.NowKey) {
            endDate = DateTimeUtils.createDateFromLong(new Date());
        }
        this.getFirstElement(this.LPViewMap.date_input_end).value = lpUtils.formatDateAsString(endDate, true);
    };


    /**
     *  On reset set to "now" and reset the buttons
     */
    TimeFrameViewController.prototype.reset = function () {
        this.uiData = lpUtils.cloneObject(this.defaultFilter);
        this.refresh();
    };
    /**
     *  Set the filter according to the data in the filter
     */
    TimeFrameViewController.prototype.refresh = function () {
        if(this.timeFrame) {

            // update the timeFrame elements
            if (this.uiData.endDate && this.uiData.endDate.getDate && isNaN(this.uiData.endDate.getDate())) {
                this.uiData.endDate = this.NowKey;
                this.checkEndDateChange();
            }
            this.timeFrame.updateStartDatePicker(this.uiData.startDate);
            if (this.uiData.endDate === this.NowKey) {
                this.timeFrame.updateEndDatePicker(DateTimeUtils.createDateFromLong(new Date()));
            } else {
                this.timeFrame.updateEndDatePicker(this.uiData.endDate);
            }
            // update the date's inputs
            this.updateDateInputs();
            // update the time dropDowns
            this.startTimeVC.setSelectedIndex(DateTimeUtils.getIndexOfTime(this.uiData.startDate));
            this.endTimeVC.setSelectedIndex(DateTimeUtils.getIndexOfTime(this.uiData.endDate, true));
        }
    };
    /**
     * Callback function for start time Dropdown change
     * @param data
     */
    TimeFrameViewController.prototype.startTimeChange = function (data) {
        this.uiData.startDate.setHours(data.rowData.hour);
        this.uiData.startDate.setMinutes(data.rowData.minute);

        this.checkStartDateChange();
    };
    /**
     * Callback function for end time Dropdown change
     * @param data
     */
    TimeFrameViewController.prototype.endTimeChange = function (data) {
        if (data.rowData.key === this.NowKey) {
            //set the "from" date according to "now"
            this.timeFrame.onNowSelectedOnDropdown(new Date());
            //reset the now button to "now" so it's not the current hour
            this.updateNowClick();
        }  else {
            if (this.uiData.endDate === this.NowKey) {
                this.uiData.endDate = DateTimeUtils.createDateFromLong(new Date());
            }
            this.uiData.endDate.setSeconds(0);
            this.uiData.endDate.setMilliseconds(0);
            this.uiData.endDate.setHours(data.rowData.hour);
            this.uiData.endDate.setMinutes(data.rowData.minute);
        }

        this.checkEndDateChange();
    };

    /**
     * When clicking "now" in the dropdown - update all relevant locations
     */
    TimeFrameViewController.prototype.updateNowClick = function () {
        this.uiData.endDate = this.NowKey;
        this.endTimeVC.setSelectedIndex(DateTimeUtils.getIndexOfTime(this.uiData.endDate, true));
        this.updateDateInputs();
    };

    /**
     * If start date is bigger that end date update the end date
     */
    TimeFrameViewController.prototype.checkStartDateChange = function(){
        // if the end date is now we need to convert it to real time for the if statements
        var tempEndDate;
        if (this.uiData.endDate === this.NowKey) {
            tempEndDate = DateTimeUtils.createDateFromLong(new Date());
        } else {
            tempEndDate = this.uiData.endDate;
        }

        if (this.uiData.startDate >= tempEndDate) {
            this.uiData.endDate = DateTimeUtils.createDateFromLong(new Date(this.uiData.startDate.getTime() + (1000 * 60 * 30)));
            this.timeFrame.updateEndDatePicker(this.uiData.endDate);
            this.endTimeVC.setSelectedIndex(DateTimeUtils.getIndexOfTime(this.uiData.endDate, true));
        }
    };
    /**
     *  If end date is smaller then start date update the start date
     */
    TimeFrameViewController.prototype.checkEndDateChange = function(){
        var endDate = this.uiData.endDate;
        if (endDate === this.NowKey) {
            endDate = DateTimeUtils.createDateFromLong(new Date());
        }
        this.timeFrame.updateEndDatePicker(endDate);
        if (endDate <= this.uiData.startDate) {
            this.uiData.startDate = DateTimeUtils.createDateFromLong(new Date(endDate.getTime() - (1000 * 60 * 30)));
            this.timeFrame.updateStartDatePicker(this.uiData.startDate);
            this.startTimeVC.setSelectedIndex(DateTimeUtils.getIndexOfTime(this.uiData.startDate));
        }
    };

    /**
     * set date pickers visible
     */
    TimeFrameViewController.prototype.showDatePickers = function() {
        this.timeFrame.showStartDatePicker();
        this.timeFrame.showEndDatePicker();
    };

    /**
     * set date pickers hidden
     */
    TimeFrameViewController.prototype.hideDatePickers = function() {
        this.timeFrame.hideStartDatePicker();
        this.timeFrame.hideEndDatePicker();
    };


    return TimeFrameViewController;

});
